<h1 mat-dialog-title>Opret tilkald</h1>
<button class="btn-close btn-icon" mat-dialog-close title="Luk dialog">
  <mat-icon class="material-icons">close</mat-icon>
</button>

<div mat-dialog-content>
  <div class="service service--create">
    <form [formGroup]="form" [attr.autocomplete]="'off'">
      <div class="form-row">
        <mat-form-field appearance="outline" color="primary">
          <mat-label>Ønsket deadline</mat-label>
          <input
            matInput
            [matDatepicker]="picker"
            formControlName="deadline"
            (click)="picker.open()"
            [min]="today"
          />
          <mat-datepicker-toggle
            matPrefix
            [for]="picker"
          ></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="form-row">
        <mat-form-field appearance="outline">
          <mat-label>Note til serviceordre</mat-label>
          <textarea formControlName="note" matInput rows="3"></textarea>
          <mat-hint align="end">
            <app-character-count
              [control]="note"
              [maxlength]="500"
            ></app-character-count>
          </mat-hint>
          <mat-error *ngIf="note?.hasError('minlength')"
            >Note til tilkald skal være mindst 3 karakterer lang.</mat-error
          >
          <mat-error *ngIf="note?.hasError('maxlength')"
            >Note til tilkald må højest være 500 karakterer lang.</mat-error
          >
        </mat-form-field>
      </div>
    </form>
  </div>
</div>
<div mat-dialog-actions class="row-reverse">
  <button
    mat-raised-button
    color="primary"
    (click)="submit()"
    [disabled]="form?.invalid"
  >
    Opret tilkald
  </button>
  <button
    mat-dialog-close
    mat-raised-button
    [routerLink]="['']"
    class="modal-cancel"
  >
    Fortryd
  </button>
</div>
